import { ReactNode } from "react";
import { Footer } from "@/components/layout/Footer";
import MainNav from "@/components/MainNav";
import { useScrollToTop } from "@/hooks/useScrollToTop";
import { Toaster } from "@/components/ui/toaster";
interface PageLayoutProps {
  children: ReactNode;
  hideFooter?: boolean;
  title?: string;
  description?: string;
  icon?: ReactNode;
  hideIcon?: boolean;
  hideHeader?: boolean;
}
const PageLayout = ({
  children,
  hideFooter = false,
  title,
  description,
  icon,
  hideIcon = false,
  hideHeader = false
}: PageLayoutProps) => {
  useScrollToTop();
  return <div className="flex flex-col min-h-screen">
      <MainNav />
      <main className="flex-grow pt-16">
        {/* Only render header if not hidden and title exists */}
        {!hideHeader && title && <div className="bg-gradient-to-r from-primary/5 via-primary/10 to-primary/5">
            
          </div>}
        {children}
      </main>
      {!hideFooter && <Footer />}
      <Toaster />
    </div>;
};
export default PageLayout;